import "core-js/modules/es6.regexp.split";
import { ApolloLink } from "./ApolloLink.js";
export var split = ApolloLink.split;